import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuthentication } from 'src/lib/auth/actions';
import { ChallengePlanId } from 'src/pages/types';
import { saveShippingAddress } from 'src/services';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { ChallengeAddonModal, setChallengeModalOpen } from 'src/store/payment';

export const useChallengeAddonModals = ({
  refetchProduct,
  handlePurchase,
}: {
  refetchProduct: () => void;
  handlePurchase: () => Promise<void>;
}) => {
  const dispatch = useAppDispatch();
  const reduxDispatch = useDispatch();

  const { challengeAddOnProduct } = useAppSelector(state => state.payment);
  const { shippingAddress, proteinFlavor } = useAppSelector(
    state => state.signUp
  );

  const isChallengeOnly =
    challengeAddOnProduct?.challengeId === ChallengePlanId.ONLY_CHALLENGE;
  const isPersonalCoach =
    challengeAddOnProduct?.challengeId === ChallengePlanId.PERSON_COACH;

  const isPurchaseAllowed = isChallengeOnly || isPersonalCoach;

  const [isLoading, setIsLoading] = useState(false);

  const handleCloseAll = (modalKey: keyof ChallengeAddonModal) => {
    dispatch(setChallengeModalOpen({ [modalKey]: false }));
  };

  const handleCTAClickModal1 = async () => {
    try {
      setIsLoading(true);
      if (isPurchaseAllowed) {
        await handlePurchase();
        dispatch(
          setChallengeModalOpen({
            isAddonContentModalOpen: false,
            isConfirmationModalOpen: true,
          })
        );
      } else {
        dispatch(
          setChallengeModalOpen({
            isAddonContentModalOpen: false,
            isShippingAddressModalOpen: true,
          })
        );
      }
    } catch (e) {
      console.error('Failed to Purchase Product : ', e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCTAClickModal2 = async () => {
    try {
      setIsLoading(true);
      if (shippingAddress) {
        await saveShippingAddress(shippingAddress, proteinFlavor ?? undefined);
      }
      await handlePurchase();
      dispatch(
        setChallengeModalOpen({
          isShippingAddressModalOpen: false,
          isConfirmationModalOpen: true,
        })
      );
    } catch (e) {
      console.error('Failed to Save Address and Purchase Product : ', e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal3 = () => {
    dispatch(setChallengeModalOpen({ isConfirmationModalOpen: false }));
    reduxDispatch(checkAuthentication());
    refetchProduct();
  };

  return {
    isLoading,
    handleCTAClickModal1,
    handleCTAClickModal2,
    handleCloseModal3,
    handleCloseAll,
  };
};
